import { schedule } from '@ember/runloop';
import { on } from '@ember/object/evented';
import Mixin from '@ember/object/mixin';
import { VERSION } from '@ember/version';
import EmberObject from '@ember/object';
import Em from 'ember';

// The contents of this lib file have been inlined from https://github.com/GavinJoyce/ember-component-inbound-actions
// so that we can drop the dependency on this unmaintained addon using deprecated ember dependencies

const ActionProxy = EmberObject.extend(Em.ActionHandler);
let scheduleInAfterRender = /^1\.13|^[2-9]/.test(VERSION);
export default Mixin.create({
  _inbound_actions_setup: on('init', function () {
    this._inbound_actions_maybeScheduleInAfterRender(() => {
      let proxy = ActionProxy.create({
        target: this
      });
      this.set('actionReceiver', proxy);
    });
  }),
  _inbound_actions_maybeScheduleInAfterRender(fn) {
    if (scheduleInAfterRender) {
      schedule('afterRender', this, fn);
    } else {
      fn();
    }
  },
  onDestroy: on('willDestroyElement', function () {
    this.set('actionReceiver', null);
  })
});